var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12H2.33333V4.66667H11.6667M9.66667 0V1.33333H4.33333V0H3V1.33333H2.33333C1.59333 1.33333 1 1.92667 1 2.66667V12C1 12.3536 1.14048 12.6928 1.39052 12.9428C1.64057 13.1929 1.97971 13.3333 2.33333 13.3333H11.6667C12.0203 13.3333 12.3594 13.1929 12.6095 12.9428C12.8595 12.6928 13 12.3536 13 12V2.66667C13 2.31304 12.8595 1.97391 12.6095 1.72386C12.3594 1.47381 12.0203 1.33333 11.6667 1.33333H11V0M10.3333 7.33333H7V10.6667H10.3333V7.33333Z",
    fill: "#6C7275",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCalendar);
export default __webpack_public_path__ + "static/media/mdi_calendar.56e3356b1460357247adf6448177eac8.svg";
export { ForwardRef as ReactComponent };